import styled, { css } from 'styled-components';

import { DragItemWrapperProps, PreviewContainerProps } from './types';

export const DragItemWrapper = styled.div<DragItemWrapperProps>`
  opacity: ${({ isDragging }) => (isDragging ? '.7' : '1')};
`;

export const PreviewContainer = styled.div<PreviewContainerProps>`
  position: absolute;
  left: -9999px;
  top: 0;
  opacity: 1;
  z-index: -1;

  img {
    width: 50px;
  }

  ${({ sizes }) =>
    sizes &&
    css`
      width: ${sizes.width}px;
      height: ${sizes.height}px;

      img {
        width: ${sizes.width}px;
        height: ${sizes.height}px;
        object-fit: contain;
      }
    `}
`;
